import React, { Component } from 'react';
import AuthService from '../AuthService';
import constants from '../../config';

var Auth = new AuthService();

function SettingCard(props) {
  var isDark = props.isDark;
  return (
    <div className="tw-rounded-xl tw-p-5 tw-mb-4" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
      <div className="tw-flex tw-items-center tw-gap-2 tw-mb-3">
        <i className={'fa ' + props.icon} style={{ color: props.color || '#c9a84c' }} />
        <h3 className="tw-text-sm tw-font-semibold tw-m-0" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>{props.title}</h3>
      </div>
      {props.children}
    </div>
  );
}

function ToggleSwitch(props) {
  return (
    <label className="tw-flex tw-items-center tw-gap-3 tw-cursor-pointer tw-mb-0">
      <button
        type="button"
        role="switch"
        aria-checked={!!props.checked}
        aria-label={props.label}
        onClick={function(e) { e.preventDefault(); props.onChange(!props.checked); }}
        className="tw-flex-shrink-0 tw-relative tw-border-0 tw-cursor-pointer tw-rounded-full tw-transition-colors"
        style={{ width: '44px', height: '24px', backgroundColor: props.checked ? (props.color || '#c9a84c') : '#ccc', padding: 0 }}
      >
        <span
          className="tw-block tw-rounded-full tw-bg-white tw-transition-all"
          style={{ width: '20px', height: '20px', marginTop: '2px', marginLeft: props.checked ? '22px' : '2px', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }}
        />
      </button>
      <div>
        <span className="tw-text-sm tw-font-medium" style={{ color: props.isDark ? '#fff' : '#1a1a1a' }}>{props.label}</span>
        {props.hint ? <span className="tw-block tw-text-xs tw-mt-0.5" style={{ color: '#999' }}>{props.hint}</span> : null}
      </div>
    </label>
  );
}

function SaveButton(props) {
  var isDisabled = props.saving || props.disabled;
  return (
    <button
      onClick={props.onClick}
      disabled={isDisabled}
      className="tw-px-5 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-semibold tw-text-white tw-border-0 tw-transition-all"
      style={{ backgroundColor: props.color || '#c9a84c', opacity: isDisabled ? 0.4 : 1, cursor: isDisabled ? 'default' : 'pointer' }}
    >
      {props.saving ? (
        <span><i className="fa fa-circle-o-notch fa-spin tw-mr-1.5" />Saving...</span>
      ) : (
        <span><i className="fa fa-check tw-mr-1.5" />{props.label || 'Save'}</span>
      )}
    </button>
  );
}

function SuccessToast(props) {
  if (!props.visible) return null;
  return (
    <div
      className="tw-px-4 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-2 tw-mb-3"
      style={{ backgroundColor: 'rgba(16,185,129,0.1)', color: '#10B981', animation: 'hp-fadeUp 0.3s ease' }}
    >
      <i className="fa fa-check-circle" />
      {props.message || 'Saved successfully!'}
    </div>
  );
}

class AdminSiteSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      configs: [],
      loading: true,
      // Announcement
      announcementEnabled: false,
      announcementText: '',
      announcementType: 'info',
      // Maintenance
      maintenanceMode: false,
      maintenanceMessage: '',
      // Spotlight
      spotlightEnabled: false,
      spotlightTitle: '',
      spotlightImage: '',
      spotlightCtaText: '',
      spotlightCtaLink: '',
      spotlightUploading: false,
      // Save states
      savingAnnouncement: false,
      savingMaintenance: false,
      savingSpotlight: false,
      // Original values (for dirty tracking)
      _origSpotlightEnabled: false,
      _origSpotlightTitle: '',
      _origSpotlightImage: '',
      _origSpotlightCtaText: '',
      _origSpotlightCtaLink: '',
      _origAnnouncementEnabled: false,
      _origAnnouncementText: '',
      _origAnnouncementType: 'info',
      _origMaintenanceMode: false,
      _origMaintenanceMessage: '',
      // Toast feedback
      toastAnnouncement: false,
      toastMaintenance: false,
      toastSpotlight: false,
      toastUpload: false,
      // Card sync
      syncing: false,
      syncResult: null,
      cardCount: 0,
      lastSync: null,
    };
    this.fetchConfigs = this.fetchConfigs.bind(this);
    this.saveConfig = this.saveConfig.bind(this);
    this.deleteConfig = this.deleteConfig.bind(this);
    this.handleSaveAnnouncement = this.handleSaveAnnouncement.bind(this);
    this.handleSaveMaintenance = this.handleSaveMaintenance.bind(this);
    this.handleSyncCards = this.handleSyncCards.bind(this);
    this.fetchSyncStatus = this.fetchSyncStatus.bind(this);
    this.handleSaveSpotlight = this.handleSaveSpotlight.bind(this);
    this.handleSpotlightImageUpload = this.handleSpotlightImageUpload.bind(this);
  }

  componentDidMount() {
    this.fetchConfigs();
    this.fetchSyncStatus();
    this._handleThemeChanged = function() { this.forceUpdate(); }.bind(this);
    window.addEventListener('themeChanged', this._handleThemeChanged);
  }

  componentWillUnmount() {
    var self = this;
    if (self._toastTimers) {
      Object.keys(self._toastTimers).forEach(function(k) { clearTimeout(self._toastTimers[k]); });
    }
    if (this._handleThemeChanged) window.removeEventListener('themeChanged', this._handleThemeChanged);
  }

  showToast(key) {
    var self = this;
    if (!self._toastTimers) self._toastTimers = {};
    var update = {};
    update[key] = true;
    self.setState(update);
    if (self._toastTimers[key]) clearTimeout(self._toastTimers[key]);
    self._toastTimers[key] = setTimeout(function() {
      var hide = {};
      hide[key] = false;
      self.setState(hide);
      delete self._toastTimers[key];
    }, 3000);
  }

  fetchConfigs() {
    var self = this;
    self.setState({ loading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/site-config')
      .then(function(data) {
        var configs = Array.isArray(data) ? data : [];
        var announcement = configs.find(function(c) { return c.key === 'announcement'; });
        var maintenance = configs.find(function(c) { return c.key === 'maintenanceMode'; });
        var spotlight = configs.find(function(c) { return c.key === 'spotlight'; });

        var aEnabled = announcement && announcement.value ? !!announcement.value.enabled : false;
        var aText = announcement && announcement.value ? (announcement.value.text || '') : '';
        var aType = announcement && announcement.value ? (announcement.value.type || 'info') : 'info';
        var mEnabled = maintenance && maintenance.value ? !!maintenance.value.enabled : false;
        var mMessage = maintenance && maintenance.value ? (maintenance.value.message || '') : '';
        var sEnabled = spotlight && spotlight.value ? !!spotlight.value.enabled : false;
        var sTitle = spotlight && spotlight.value ? (spotlight.value.title || '') : '';
        var sImage = spotlight && spotlight.value ? (spotlight.value.image || '') : '';
        var sCtaText = spotlight && spotlight.value ? (spotlight.value.ctaText || '') : '';
        var sCtaLink = spotlight && spotlight.value ? (spotlight.value.ctaLink || '') : '';

        self.setState({
          configs: configs,
          loading: false,
          // Current editable values
          announcementEnabled: aEnabled,
          announcementText: aText,
          announcementType: aType,
          maintenanceMode: mEnabled,
          maintenanceMessage: mMessage,
          spotlightEnabled: sEnabled,
          spotlightTitle: sTitle,
          spotlightImage: sImage,
          spotlightCtaText: sCtaText,
          spotlightCtaLink: sCtaLink,
          // Original values (for dirty detection)
          _origAnnouncementEnabled: aEnabled,
          _origAnnouncementText: aText,
          _origAnnouncementType: aType,
          _origMaintenanceMode: mEnabled,
          _origMaintenanceMessage: mMessage,
          _origSpotlightEnabled: sEnabled,
          _origSpotlightTitle: sTitle,
          _origSpotlightImage: sImage,
          _origSpotlightCtaText: sCtaText,
          _origSpotlightCtaLink: sCtaLink,
        });
      })
      .catch(function(err) { console.log('Failed to fetch configs:', err); self.setState({ loading: false }); });
  }

  saveConfig(key, value, callback) {
    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/site-config/' + encodeURIComponent(key), {
      method: 'PUT',
      body: JSON.stringify({ value: value }),
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function() {
        self.fetchConfigs();
        if (callback) callback(null);
      })
      .catch(function(err) { alert('Failed to save: ' + (err.message || 'Unknown error')); if (callback) callback(err); });
  }

  deleteConfig(key) {
    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/site-config/' + encodeURIComponent(key), {
      method: 'DELETE',
    })
      .then(function() { self.fetchConfigs(); })
      .catch(function(err) { alert('Failed to delete: ' + (err.message || 'Unknown error')); });
  }

  handleSaveAnnouncement() {
    var self = this;
    self.setState({ savingAnnouncement: true });
    self.saveConfig('announcement', {
      enabled: self.state.announcementEnabled,
      text: self.state.announcementText,
      type: self.state.announcementType,
    }, function(err) {
      self.setState({ savingAnnouncement: false });
      if (!err) self.showToast('toastAnnouncement');
    });
  }

  handleSaveMaintenance() {
    var self = this;
    self.setState({ savingMaintenance: true });
    self.saveConfig('maintenanceMode', {
      enabled: self.state.maintenanceMode,
      message: self.state.maintenanceMessage,
    }, function(err) {
      self.setState({ savingMaintenance: false });
      if (!err) self.showToast('toastMaintenance');
    });
  }

  fetchSyncStatus() {
    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/sync-cards/status')
      .then(function(data) {
        self.setState({
          cardCount: data.cardCount || 0,
          lastSync: data.lastSync || null,
        });
      })
      .catch(function() { /* ignore */ });
  }

  handleSyncCards() {
    var self = this;
    if (!window.confirm('Sync card catalog from PrimalTCG database? This may take a moment.')) return;
    self.setState({ syncing: true, syncResult: null });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/sync-cards', {
      method: 'POST',
    })
      .then(function(data) {
        self.setState({
          syncing: false,
          syncResult: data,
          cardCount: data.totalLocal || self.state.cardCount,
        });
        self.fetchSyncStatus();
      })
      .catch(function(err) {
        self.setState({ syncing: false, syncResult: { error: err.message || 'Sync failed' } });
      });
  }

  handleSaveSpotlight() {
    var self = this;
    self.setState({ savingSpotlight: true });
    self.saveConfig('spotlight', {
      enabled: self.state.spotlightEnabled,
      title: self.state.spotlightTitle,
      image: self.state.spotlightImage,
      ctaText: self.state.spotlightCtaText,
      ctaLink: self.state.spotlightCtaLink,
    }, function(err) {
      self.setState({ savingSpotlight: false });
      if (!err) self.showToast('toastSpotlight');
    });
  }

  handleSpotlightImageUpload(e) {
    var file = e.target.files && e.target.files[0];
    if (!file) return;
    var self = this;
    self.setState({ spotlightUploading: true });
    var formData = new FormData();
    formData.append('image', file);
    var authHeader = require('../../utils/authHeader').getAuthHeader();
    fetch(constants.DOMAIN + '/api/v1/admin/spotlight/upload-image', {
      method: 'POST',
      headers: { 'Authorization': authHeader },
      body: formData,
    })
      .then(function(res) {
        if (!res.ok) throw new Error('Server returned ' + res.status);
        return res.json();
      })
      .then(function(data) {
        if (data.error) {
          self.setState({ spotlightUploading: false });
          alert(data.error);
        } else if (data.config && data.config.value) {
          self.setState({ spotlightImage: data.config.value.image || '', spotlightUploading: false });
          self.showToast('toastUpload');
        } else {
          self.setState({ spotlightUploading: false });
          alert('Failed to upload image');
        }
      })
      .catch(function(err) { console.log('Upload failed:', err); self.setState({ spotlightUploading: false }); alert('Failed to upload image'); });
    // Reset file input so same file can be re-selected
    e.target.value = '';
  }

  render() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');

    if (this.state.loading) {
      return (
        <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
          <div className="tw-text-center">
            <i className="fa fa-circle-o-notch fa-spin tw-text-3xl tw-mb-3" style={{ color: '#c9a84c', display: 'block' }} />
            <span className="tw-text-sm" style={{ color: '#999' }}>Loading settings...</span>
          </div>
        </div>
      );
    }

    var TYPE_COLORS = {
      info: { bg: '#3B82F6', label: 'Info (Blue)' },
      warning: { bg: '#f59e0b', label: 'Warning (Yellow)' },
      success: { bg: '#10B981', label: 'Success (Green)' },
      error: { bg: '#EF4444', label: 'Error (Red)' },
    };

    var spotlightDirty =
      this.state.spotlightEnabled !== this.state._origSpotlightEnabled ||
      this.state.spotlightTitle !== this.state._origSpotlightTitle ||
      this.state.spotlightImage !== this.state._origSpotlightImage ||
      this.state.spotlightCtaText !== this.state._origSpotlightCtaText ||
      this.state.spotlightCtaLink !== this.state._origSpotlightCtaLink;

    var announcementDirty =
      this.state.announcementEnabled !== this.state._origAnnouncementEnabled ||
      this.state.announcementText !== this.state._origAnnouncementText ||
      this.state.announcementType !== this.state._origAnnouncementType;

    var maintenanceDirty =
      this.state.maintenanceMode !== this.state._origMaintenanceMode ||
      this.state.maintenanceMessage !== this.state._origMaintenanceMessage;

    var inputClass = 'tw-w-full tw-px-3 tw-py-2.5 tw-rounded-lg tw-border tw-text-sm tw-transition-colors';
    var inputStyle = {
      backgroundColor: isDark ? '#222' : '#fff',
      color: isDark ? '#fff' : '#1a1a1a',
      borderColor: isDark ? '#444' : '#d0d0d0',
      outline: 'none',
    };

    return (
      <div>
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-6">
          <div>
            <h1 className="tw-text-xl tw-font-bold tw-m-0" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>Site Settings</h1>
            <p className="tw-text-sm tw-m-0 tw-mt-0.5" style={{ color: '#999' }}>Configure what visitors see on your marketplace</p>
          </div>
        </div>

        {/* Spotlight Banner — most used, so first */}
        <SettingCard isDark={isDark} icon="fa-star" title="Homepage Spotlight" color="#c9a84c">
          <div className="tw-space-y-4">
            <p className="tw-text-sm tw-m-0" style={{ color: isDark ? '#aaa' : '#666' }}>
              Promote new card sets, games, or announcements with a featured banner on the homepage.
            </p>
            <SuccessToast visible={this.state.toastSpotlight} message="Spotlight saved! Changes are live on the homepage." />
            <SuccessToast visible={this.state.toastUpload} message="Image uploaded successfully!" />
            <ToggleSwitch
              checked={this.state.spotlightEnabled}
              onChange={function(v) { self.setState({ spotlightEnabled: v }); }}
              label="Show spotlight on homepage"
              hint={this.state.spotlightEnabled ? 'Visible to all visitors' : 'Hidden from homepage'}
              color="#c9a84c"
              isDark={isDark}
            />
            {/* Image upload */}
            <div>
              <label className="tw-text-xs tw-font-medium tw-block tw-mb-1.5" style={{ color: isDark ? '#ccc' : '#555' }}>Banner Image</label>
              <div className="tw-flex tw-items-center tw-gap-4">
                {this.state.spotlightImage ? (
                  <img
                    src={constants.DOMAIN + '/' + this.state.spotlightImage}
                    alt="Spotlight preview"
                    className="tw-rounded-lg tw-object-cover"
                    style={{ width: '160px', height: '90px', border: '1px solid ' + (isDark ? '#333' : '#ddd') }}
                  />
                ) : (
                  <div className="tw-rounded-lg tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1" style={{ width: '160px', height: '90px', backgroundColor: isDark ? '#222' : '#f5f5f5', border: '2px dashed ' + (isDark ? '#444' : '#ccc') }}>
                    <i className="fa fa-image tw-text-xl" style={{ color: '#bbb' }} />
                    <span className="tw-text-xs" style={{ color: '#999' }}>No image</span>
                  </div>
                )}
                <div>
                  <label className="tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-font-medium tw-cursor-pointer tw-border tw-transition-opacity hover:tw-opacity-80 tw-mb-0 tw-inline-block" style={{ color: isDark ? '#fff' : '#1a1a1a', borderColor: isDark ? '#555' : '#d0d0d0', backgroundColor: isDark ? '#2a2a2a' : '#f9f9f9' }}>
                    {this.state.spotlightUploading ? <span><i className="fa fa-circle-o-notch fa-spin tw-mr-1.5" />Uploading...</span> : <span><i className="fa fa-cloud-upload tw-mr-1.5" />Choose Image</span>}
                    <input type="file" accept="image/*" onChange={this.handleSpotlightImageUpload} className="tw-hidden" />
                  </label>
                  <p className="tw-text-xs tw-m-0 tw-mt-1.5" style={{ color: '#999' }}>Max 10MB. Best at 1200 x 600px.</p>
                </div>
              </div>
            </div>
            {/* Title */}
            <div>
              <label className="tw-text-xs tw-font-medium tw-block tw-mb-1.5" style={{ color: isDark ? '#ccc' : '#555' }}>
                Headline <span style={{ color: '#999', fontWeight: 400 }}>— the main text visitors see</span>
              </label>
              <input
                type="text"
                value={this.state.spotlightTitle}
                onChange={function(e) { self.setState({ spotlightTitle: e.target.value }); }}
                placeholder='e.g. "Sea Invasion — Now Available"'
                className={inputClass}
                style={inputStyle}
              />
            </div>
            {/* CTA */}
            <div className="tw-flex tw-gap-3">
              <div className="tw-flex-1">
                <label className="tw-text-xs tw-font-medium tw-block tw-mb-1.5" style={{ color: isDark ? '#ccc' : '#555' }}>
                  Button Text
                </label>
                <input
                  type="text"
                  value={this.state.spotlightCtaText}
                  onChange={function(e) { self.setState({ spotlightCtaText: e.target.value }); }}
                  placeholder='e.g. "Shop Now"'
                  className={inputClass}
                  style={inputStyle}
                />
              </div>
              <div className="tw-flex-1">
                <label className="tw-text-xs tw-font-medium tw-block tw-mb-1.5" style={{ color: isDark ? '#ccc' : '#555' }}>
                  Button Link <span style={{ color: '#999', fontWeight: 400 }}>— where it goes</span>
                </label>
                <input
                  type="text"
                  value={this.state.spotlightCtaLink}
                  onChange={function(e) { self.setState({ spotlightCtaLink: e.target.value }); }}
                  placeholder='e.g. "/browse" or full URL'
                  className={inputClass}
                  style={inputStyle}
                />
              </div>
            </div>
            {/* Live preview — matches carousel slide layout */}
            {(this.state.spotlightTitle || this.state.spotlightImage) ? (
              <div>
                <label className="tw-text-xs tw-font-medium tw-block tw-mb-1.5" style={{ color: isDark ? '#ccc' : '#555' }}>
                  <i className="fa fa-eye tw-mr-1" />Preview — appears as a carousel slide on homepage
                </label>
                <div className="tw-relative tw-rounded-2xl tw-overflow-hidden" style={{ height: '220px', background: '#0a0a0a', border: '1px solid rgba(201,168,76,0.2)', boxShadow: '0 8px 32px rgba(0,0,0,0.3)' }}>
                  {/* Right: spotlight image (matches .hp-carousel-art-bg at 70% width) */}
                  <div style={{ position: 'absolute', top: 0, right: 0, width: '70%', height: '100%', overflow: 'hidden' }}>
                    {this.state.spotlightImage ? (
                      <img src={constants.DOMAIN + '/' + this.state.spotlightImage} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center 20%', display: 'block' }} />
                    ) : (
                      <div style={{ width: '100%', height: '100%', background: '#1a1a1a' }} />
                    )}
                    {/* Top/bottom vignette (matches .hp-carousel-art-vignette) */}
                    <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(10,10,10,0.4) 0%, transparent 15%, transparent 85%, rgba(10,10,10,0.6) 100%)', pointerEvents: 'none' }} />
                  </div>
                  {/* Left dissolve fade (matches .hp-carousel-art-fade) */}
                  <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(90deg, #0a0a0a 0%, #0a0a0a 5%, rgba(10,10,10,0.95) 15%, rgba(10,10,10,0.7) 30%, rgba(10,10,10,0.3) 50%, transparent 70%)', pointerEvents: 'none', zIndex: 1 }} />
                  {/* Left: text content (matches .hp-carousel-text) */}
                  <div style={{ position: 'relative', zIndex: 2, padding: '28px 32px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', maxWidth: '50%' }}>
                    <span style={{ color: '#c9a84c', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '3px', fontWeight: 600, marginBottom: '8px', display: 'inline-block' }}>Featured</span>
                    <div className="tw-font-bold tw-text-white tw-mb-2" style={{ fontSize: '20px', lineHeight: 1.15 }}>
                      {this.state.spotlightTitle || 'Your headline here'}
                    </div>
                    <div style={{ color: '#9ca3af', fontSize: '11px', marginBottom: '12px' }}>
                      {this.state.spotlightTitle || ''}
                    </div>
                    {this.state.spotlightCtaText ? (
                      <span className="tw-inline-block tw-font-semibold tw-rounded-full" style={{ background: '#c9a84c', color: '#000', fontSize: '11px', padding: '6px 20px', alignSelf: 'flex-start', letterSpacing: '0.3px' }}>
                        {this.state.spotlightCtaText} <i className="fa fa-arrow-right" style={{ fontSize: '9px', marginLeft: '5px' }} />
                      </span>
                    ) : null}
                  </div>
                </div>
              </div>
            ) : null}
            <SaveButton onClick={this.handleSaveSpotlight} saving={this.state.savingSpotlight} disabled={!spotlightDirty} label="Save Spotlight" color="#c9a84c" />
          </div>
        </SettingCard>

        {/* Announcement Banner */}
        <SettingCard isDark={isDark} icon="fa-bullhorn" title="Announcement Banner" color="#3B82F6">
          <div className="tw-space-y-4">
            <SuccessToast visible={this.state.toastAnnouncement} message="Announcement saved!" />
            <ToggleSwitch
              checked={this.state.announcementEnabled}
              onChange={function(v) { self.setState({ announcementEnabled: v }); }}
              label="Show announcement banner"
              hint={this.state.announcementEnabled ? 'Visible at the top of every page' : 'Hidden from visitors'}
              color="#3B82F6"
              isDark={isDark}
            />
            <div>
              <label className="tw-text-xs tw-font-medium tw-block tw-mb-1.5" style={{ color: isDark ? '#ccc' : '#555' }}>
                Message <span style={{ color: '#999', fontWeight: 400 }}>— keep it short and clear</span>
              </label>
              <input
                type="text"
                value={this.state.announcementText}
                onChange={function(e) { self.setState({ announcementText: e.target.value }); }}
                placeholder='e.g. "New sets available! Check out the latest drops."'
                className={inputClass}
                style={inputStyle}
              />
            </div>
            <div>
              <label className="tw-text-xs tw-font-medium tw-block tw-mb-1.5" style={{ color: isDark ? '#ccc' : '#555' }}>Color</label>
              <div className="tw-flex tw-gap-2">
                {Object.keys(TYPE_COLORS).map(function(type) {
                  var tc = TYPE_COLORS[type];
                  var isActive = self.state.announcementType === type;
                  return (
                    <button
                      key={type}
                      onClick={function() { self.setState({ announcementType: type }); }}
                      className="tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-xs tw-font-medium tw-border tw-cursor-pointer tw-transition-all"
                      style={isActive
                        ? { backgroundColor: tc.bg, color: '#fff', borderColor: 'transparent' }
                        : { backgroundColor: 'transparent', color: isDark ? '#aaa' : '#666', borderColor: isDark ? '#555' : '#d0d0d0' }
                      }
                    >
                      {tc.label}
                    </button>
                  );
                })}
              </div>
            </div>
            {/* Preview */}
            {this.state.announcementText && (
              <div>
                <label className="tw-text-xs tw-font-medium tw-block tw-mb-1.5" style={{ color: isDark ? '#ccc' : '#555' }}>
                  <i className="fa fa-eye tw-mr-1" />Preview
                </label>
                <div
                  className="tw-px-4 tw-py-2.5 tw-rounded-lg tw-text-sm tw-text-white tw-font-medium tw-text-center"
                  style={{ backgroundColor: TYPE_COLORS[this.state.announcementType].bg }}
                >
                  {this.state.announcementText}
                </div>
              </div>
            )}
            <SaveButton onClick={this.handleSaveAnnouncement} saving={this.state.savingAnnouncement} disabled={!announcementDirty} label="Save Announcement" color="#3B82F6" />
          </div>
        </SettingCard>

        {/* Maintenance Mode */}
        <SettingCard isDark={isDark} icon="fa-wrench" title="Maintenance Mode" color="#f59e0b">
          <div className="tw-space-y-4">
            <SuccessToast visible={this.state.toastMaintenance} message="Maintenance settings saved!" />
            <ToggleSwitch
              checked={this.state.maintenanceMode}
              onChange={function(v) { self.setState({ maintenanceMode: v }); }}
              label="Enable maintenance mode"
              hint={this.state.maintenanceMode ? 'Site is locked — only admins can access' : 'Site is open to everyone'}
              color="#f59e0b"
              isDark={isDark}
            />
            {this.state.maintenanceMode && (
              <div className="tw-px-3 tw-py-2.5 tw-rounded-lg tw-text-sm tw-flex tw-items-start tw-gap-2" style={{ backgroundColor: 'rgba(245,158,11,0.1)', color: '#f59e0b' }}>
                <i className="fa fa-warning tw-mt-0.5" />
                <span>Non-admin visitors will see a maintenance page and cannot access the marketplace.</span>
              </div>
            )}
            <div>
              <label className="tw-text-xs tw-font-medium tw-block tw-mb-1.5" style={{ color: isDark ? '#ccc' : '#555' }}>
                Message to show visitors
              </label>
              <textarea
                value={this.state.maintenanceMessage}
                onChange={function(e) { self.setState({ maintenanceMessage: e.target.value }); }}
                placeholder="We're performing scheduled maintenance. We'll be back shortly!"
                rows={3}
                className={'tw-w-full tw-px-3 tw-py-2.5 tw-rounded-lg tw-border tw-text-sm tw-resize-none'}
                style={inputStyle}
              />
            </div>
            <SaveButton onClick={this.handleSaveMaintenance} saving={this.state.savingMaintenance} disabled={!maintenanceDirty} label="Save Maintenance Settings" color="#f59e0b" />
          </div>
        </SettingCard>

        {/* Card Catalog Sync */}
        <SettingCard isDark={isDark} icon="fa-refresh" title="Card Catalog Sync" color="#10B981">
          <div className="tw-space-y-3">
            <p className="tw-text-sm tw-m-0" style={{ color: isDark ? '#aaa' : '#666' }}>
              Pull the latest card data from the PrimalTCG database into the marketplace catalog.
            </p>
            <div className="tw-flex tw-flex-wrap tw-gap-4">
              <div className="tw-flex tw-items-center tw-gap-2">
                <i className="fa fa-clone tw-text-xs" style={{ color: '#10B981' }} />
                <span className="tw-text-sm tw-font-medium" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>{this.state.cardCount}</span>
                <span className="tw-text-xs" style={{ color: '#999' }}>cards in catalog</span>
              </div>
              {this.state.lastSync && this.state.lastSync.lastSyncAt && (
                <div className="tw-flex tw-items-center tw-gap-2">
                  <i className="fa fa-clock-o tw-text-xs" style={{ color: '#999' }} />
                  <span className="tw-text-xs" style={{ color: '#999' }}>
                    Last synced {new Date(this.state.lastSync.lastSyncAt).toLocaleDateString()} at {new Date(this.state.lastSync.lastSyncAt).toLocaleTimeString()}
                  </span>
                </div>
              )}
            </div>
            {this.state.lastSync && (
              <div className="tw-flex tw-flex-wrap tw-gap-3 tw-text-xs" style={{ color: '#999' }}>
                <span>{this.state.lastSync.totalSource || 0} source cards</span>
                <span>{this.state.lastSync.inserted || 0} added</span>
                <span>{this.state.lastSync.updated || 0} updated</span>
                {this.state.lastSync.errors > 0 && (
                  <span style={{ color: '#EF4444' }}>{this.state.lastSync.errors} errors</span>
                )}
              </div>
            )}
            {this.state.syncResult && !this.state.syncResult.error && (
              <div className="tw-px-3 tw-py-2 tw-rounded-lg tw-text-sm" style={{ backgroundColor: 'rgba(16,185,129,0.1)', color: '#10B981' }}>
                <i className="fa fa-check-circle tw-mr-1.5" />
                Sync complete: {this.state.syncResult.inserted} new, {this.state.syncResult.updated} updated, {this.state.syncResult.totalLocal} total cards
              </div>
            )}
            {this.state.syncResult && this.state.syncResult.error && (
              <div className="tw-px-3 tw-py-2 tw-rounded-lg tw-text-sm" style={{ backgroundColor: 'rgba(239,68,68,0.1)', color: '#EF4444' }}>
                <i className="fa fa-times-circle tw-mr-1.5" />
                {this.state.syncResult.error}
              </div>
            )}
            <button
              onClick={this.handleSyncCards}
              disabled={this.state.syncing}
              className="tw-px-5 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-semibold tw-text-white tw-border-0 tw-cursor-pointer hover:tw-opacity-90 tw-transition-opacity disabled:tw-opacity-50"
              style={{ backgroundColor: '#10B981' }}
            >
              {this.state.syncing ? (
                <span><i className="fa fa-circle-o-notch fa-spin tw-mr-1.5" />Syncing...</span>
              ) : (
                <span><i className="fa fa-refresh tw-mr-1.5" />Sync Now</span>
              )}
            </button>
          </div>
        </SettingCard>

        {/* Admin Modules */}
        <SettingCard isDark={isDark} icon="fa-puzzle-piece" title="Admin Modules" color="#6366F1">
          <div className="tw-space-y-1">
            <p className="tw-text-sm tw-m-0 tw-mb-3" style={{ color: isDark ? '#aaa' : '#666' }}>
              Toggle optional admin pages on or off. Nothing is deleted — you can re-enable anytime.
            </p>
            {[
              { flag: 'flag_ledger', label: 'Payment Ledger', desc: 'Chronological log of all payment events (charges, payouts, refunds)' },
              { flag: 'flag_balances', label: 'Seller Balances', desc: 'Overview of held funds per seller with batch payout release' },
            ].map(function(mod) {
              var flagConfig = self.state.configs.find(function(c) { return c.key === mod.flag; });
              var isEnabled = flagConfig && flagConfig.value && flagConfig.value.enabled;
              return (
                <div key={mod.flag} className="tw-flex tw-items-center tw-justify-between tw-py-3 tw-px-3 tw-rounded-lg" style={{ border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
                  <div className="tw-flex-1 tw-min-w-0 tw-mr-3">
                    <div className="tw-text-sm tw-font-medium" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>{mod.label}</div>
                    <div className="tw-text-xs tw-mt-0.5" style={{ color: '#999' }}>{mod.desc}</div>
                  </div>
                  <button
                    onClick={function() { self.saveConfig(mod.flag, { enabled: !isEnabled }); }}
                    className="tw-flex-shrink-0 tw-relative tw-border-0 tw-cursor-pointer tw-rounded-full tw-transition-colors"
                    style={{ width: '44px', height: '24px', backgroundColor: isEnabled ? '#10B981' : '#ccc', padding: 0 }}
                  >
                    <span
                      className="tw-block tw-rounded-full tw-bg-white tw-transition-all"
                      style={{ width: '20px', height: '20px', marginTop: '2px', marginLeft: isEnabled ? '22px' : '2px', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }}
                    />
                  </button>
                </div>
              );
            })}
          </div>
        </SettingCard>

      </div>
    );
  }
}

export default AdminSiteSettings;
